import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const TypeOther = () => {
  const { control } = useFormContext<SarEdit>()
  const type = useWatch({ control, name: 'institutionContactInfo.type' })

  return (
    <Controller
      name="institutionContactInfo.typeOther"
      control={control}
      rules={{
        validate: (value) => (type === 'Other' ? Validators.required.field(value) : undefined)
      }}
      render={({ field }) => (
        <FF2
          required={type === 'Other'}
          field={field}
          label="Other"
          input={(props) => <TextInput {...props} disabled={type !== 'Other'} />}
        />
      )}
    />
  )
}
